__turbopack_context__.v({
  "Root--UpDown": "_9hmTCW_Root--UpDown",
  "skeleton-loading": "_9hmTCW_skeleton-loading",
});
